import { Tooltip, Typography } from "@mui/material";
import Rating from "@mui/material/Rating";
import React, { useEffect, useState } from "react";
import { CgCloseO } from "react-icons/cg";
import RadarGraph from "./charts/RadarGraphBlenderSolo";
import Poster from "./Poster";

function UnitResult(props) {
  // Handle radar chart font size
  var radarFontSizeInit;
  if (window.innerWidth < 768) {
    radarFontSizeInit = 5;
  } else {
    radarFontSizeInit = 8;
  }

  const [radarFontSize, setRadarFontSize] = useState(radarFontSizeInit);
  useEffect(() => {
    function handleResize() {
      //   console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      if (window.innerWidth < 768) {
        setRadarFontSize(5);
      } else {
        setRadarFontSize(8);
      }
    }

    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <div className="w-32 md:w-48">
      {/* Content title */}
      <div className="flex flex-col h-10 mb-2">
        <p
          className={`mt-auto font-[Karla] text-md leading-4
                                            `}
        >
          {props.ind <= 4 && `${props.ind + 1}.`} {props.option.show_name}
        </p>
      </div>

      {/* Result Posters */}

      {props.option && props.option.poster_link && (
        <Tooltip
          title={
            <React.Fragment>
              <Typography color="inherit">{props.option.show_name}</Typography>
              <b>{"Genre: "}</b>
              <em>{props.option.genres}</em>
              <br />
            </React.Fragment>
          }
        >
          <div>
            <Poster option={props.option} />
          </div>
        </Tooltip>
      )}

      {/* Evaluation */}
      <div className="flex justify-center h-10 items-center mt-2">
        <div className="mt-1 mx-0.5">
          <Rating name="read-only" size="small" value={1} max={1} readOnly />
        </div>
        <div className="">
          <p className="text-xs text-gray-400">
            {props.option.evaluation_score} / 5
            {/* <Rating
            name="read-only"
            size="small"
            value={props.option.evaluation_score}
            precision={0.1}
            readOnly
          /> */}
          </p>
        </div>
      </div>

      {/* Current networks (platform) */}
      <div className="mt-0 -mb-4">
        <p
          className={`text-xs italic
                               ${
                                 props.option.current_network_names
                                   ? "text-gray-500"
                                   : "opacity-0"
                               }
                              `}
        >
          {props.option.current_network_names
            ? props.option.current_network_names.join(", ")
            : "No current networks"}
        </p>
      </div>

      {/* Result Radar Charts */}
      <CgCloseO
        name={props.ind}
        className="bg-white rounded-full text-2xl
                                text-gray-700
                                ring-[1px] ring-gray-700 ring-inset
                                hover:ring-4 hover:ring-slate-100
                                -mb-3 ml-44 z-30 relative
                                opacity-0
                                "
      />
      <div className="w-36 md:w-48">
        <RadarGraph
          data={props.radarChartDataResult[props.ind]}
          showName={"closest show name"}
          refShowName={props.selectedOption[0].name}
          refShow={true}
          // returnProximity={blenderData}
          color={props.colorCodes[0]}
          hideLegend={true}
          labelFontSize={radarFontSize}
        />
      </div>
      <div className="text-xs -mt-6 mb-10 text-gray-400">
        <p>Incidence Rate: {props.option.incidence_rate.toFixed(2)}</p>
        <p>Intentionality: {props.option.intentionality.toFixed(0)}</p>

        {props.option.percentile_rank_pay_exclusive && (
          <p>
            Content Acquisition:{" "}
            {props.option.percentile_rank_pay_exclusive.toFixed(0)}
          </p>
        )}
        <p>
          Evaluation: {props.option.percentile_rank_evaluation_score.toFixed(0)}
        </p>
      </div>
    </div>
  );
}

export default UnitResult;
